import * as yup from 'yup';

const SignUpSchema = yup.object().shape({
    firstName: yup.string().required("First name is required"),
    surName: yup.string(),
    phone: yup.string().min(10, "").max(20, "").required("Phone number must be valid")
})
export default SignUpSchema;